export const dateParser = (value: string | number | undefined | null): string => {
  if (typeof value !== 'string') return value == null ? '' : String(value);
  const v = value.trim();

  // If too short to be a valid m/dd/yyyy or mmddyyyy, return a mask-friendly version
  if (v.length < 7 || (v.length == 0 && v[0] == '0')) {
    return formatDigitsForMask(v);
  }

  let month: number | undefined;
  let day: number | undefined;
  let year: number | undefined;

  const slashMatch = v.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (slashMatch) {
    month = Number(slashMatch[1]);
    day = Number(slashMatch[2]);
    year = Number(slashMatch[3]);
  } else if (/^\d{8}$/.test(v)) {
    month = Number(v.substring(0, 2));
    day = Number(v.substring(2, 4));
    year = Number(v.substring(4, 8));
  } else if (/^\d{7}$/.test(v)) {
    // Try MM/dd/yyy format first (incomplete year)
    const mm = Number(v.substring(0, 2));
    const dd = Number(v.substring(2, 4));

    if (mm >= 1 && mm <= 12 && dd >= 1 && dd <= 31) {
      // Valid MM/dd pattern - treat as incomplete input
      return formatDigitsForMask(v);
    } else {
      // Treat as M/dd/yyyy (single-digit month, complete year)
      month = Number(v.substring(0, 1));
      day = Number(v.substring(1, 3));
      year = Number(v.substring(3, 7));
    }
  } else {
    // Non-digit or other forms -> preserve a mask-friendly representation
    return v.includes('/') ? v : formatDigitsForMask(v);
  }

  if (!year) return formatDigitsForMask(v);
  if (!month || month < 1 || month > 12) return formatDigitsForMask(v);
  if (!day || day < 1 || day > 31) return formatDigitsForMask(v);

  // Format the date components directly without JavaScript Date validation
  // This allows invalid dates (like 0001-01-01) to reach the backend for proper validation
  const yearStr = String(year).padStart(4, '0');
  const monthStr = String(month).padStart(2, '0');
  const dayStr = String(day).padStart(2, '0');

  return `${yearStr}-${monthStr}-${dayStr}`;
};

function formatDigitsForMask(v: string): string {
  if (!/^\d+$/.test(v)) return v;

  const len = v.length;
  if (len >= 8) {
    return `${v.substring(0, 2)}/${v.substring(2, 4)}/${v.substring(4, 8)}`;
  }
  if (len === 7) {
    // Check if first two digits could be MM/dd (incomplete) vs M/dd (complete)
    const mm = Number(v.substring(0, 2));
    const dd = Number(v.substring(2, 4));

    if (mm >= 1 && mm <= 12 && dd >= 1 && dd <= 31) {
      // Valid MM/dd pattern - format as MM/dd/yyy
      return `${v.substring(0, 2)}/${v.substring(2, 4)}/${v.substring(4, 7)}`;
    } else {
      // Format as M/dd/yyyy
      return `${v.substring(0, 1)}/${v.substring(1, 3)}/${v.substring(3, 7)}`;
    }
  }
  if (len === 6) {
    return `${v.substring(0, 2)}/${v.substring(2, 4)}/${v.substring(4, 6)}`;
  }
  if (len === 5) {
    return `${v.substring(0, 2)}/${v.substring(2, 4)}/${v.substring(4)}`;
  }
  if (len === 4) {
    return `${v.substring(0, 2)}/${v.substring(2)}`;
  }
  if (len === 3) {
    return `${v.substring(0, 1)}/${v.substring(1)}`;
  }
  // len 1-2
  return v;
}
